<template>
    <div>
      <EditPR/>
    </div>
  </template>
  
  <script>
  // @ is an alias to /src
  import EditPR from '@/components/EditPR.vue'
  
  export default {
    name: 'create-pr-view',
    components: {
      EditPR
    }
  }
  </script>
  